// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1ivDq","footer":"ModalCreateQualiphyProcedure_footer__JLd26","additionData":"ModalCreateQualiphyProcedure_additionData__fUjME"};